import React, { useEffect, useRef, useState } from 'react';
import { Animated, Dimensions, Easing, Platform, StyleSheet, Text, TextInput, View, } from 'react-native';
import { Typography } from "../typography/Typography";
import { ColorTokens, FontFamilyTokens, FontSizeTokens } from "@voltmoney/schema";
import ThemeProvider from "@voltmoney/theme";
import { isMobile } from "../stack/utils";
import { getScreenType } from "./bankSelectPage/BankSelect";
import { isFromTDLPlatform } from './utils';
const theme = ThemeProvider.getTheme();
const fontFamilyMapping = theme.fontFamily;
const isfromTDL = isFromTDLPlatform();
const TextField = (props) => {
    const { label, errorText, value, style, onBlur, onFocus, showError, ...restOfProps } = props;
    const [isFocused, setIsFocused] = useState(false);
    const inputRef = useRef(null);
    const focusAnim = useRef(new Animated.Value(0)).current;
    useEffect(() => {
        if (value !== "") {
            setIsFocused(true);
        }
        else {
            setIsFocused(false);
        }
    }, [value]);
    useEffect(() => {
        Animated.timing(focusAnim, {
            toValue: isFocused || !!value ? 1 : 0,
            duration: 150,
            easing: Easing.bezier(0.4, 0, 0.2, 1),
            useNativeDriver: true,
        }).start();
    }, [focusAnim, isFocused, value]);
    let color = isFocused ? props.focusColor : '#98A2B3';
    if (showError && errorText) {
        color = '#B00020';
    }
    return (React.createElement(View, { style: style },
        React.createElement(TextInput, { style: [
                styles.input,
                {
                    borderColor: color,
                    zIndex: isFocused ? 0 : 1,
                    borderRadius: isfromTDL ? 8 : 4
                },
            ], ref: inputRef, ...restOfProps, value: value, onBlur: (event) => {
                setIsFocused(false);
                onBlur?.(event);
            }, onFocus: (event) => {
                setIsFocused(true);
                onFocus?.(event);
            } }),
        React.createElement(Animated.View, { style: [
                styles.labelContainer,
                {
                    zIndex: value ? 1 : 0
                },
                {
                    transform: [
                        {
                            scale: focusAnim.interpolate({
                                inputRange: [0, 1],
                                outputRange: [1, 0.75],
                            }),
                        },
                        {
                            translateY: focusAnim.interpolate({
                                inputRange: [0, 1],
                                outputRange: [13, -10],
                            }),
                        },
                        {
                            translateX: focusAnim.interpolate({
                                inputRange: [0, 1],
                                outputRange: [16, 0],
                            }),
                        },
                    ],
                },
            ] },
            React.createElement(Typography, { label: isFocused || value !== "" ? label : props.holder, fontFamily: FontFamilyTokens.Inter, color: !isFocused ? ColorTokens.Grey_Smoke : ColorTokens.Grey_Night, fontSize: Platform.OS === 'web' ? isMobile(getScreenType(Dimensions.get('window').width)) ? FontSizeTokens.SM : FontSizeTokens.MD : FontSizeTokens.SM })),
        !!errorText && showError && React.createElement(Text, { style: styles.error }, errorText)));
};
const styles = StyleSheet.create({
    input: {
        paddingHorizontal: 16,
        paddingVertical: 12,
        borderWidth: 1,
        color: '#1D2939',
        fontFamily: fontFamilyMapping.Inter,
        fontSize: 16,
    },
    labelContainer: {
        position: 'absolute',
        paddingHorizontal: 4,
        backgroundColor: 'white',
    },
    label: {
        fontFamily: 'Avenir-Heavy',
        fontSize: 14,
    },
    error: {
        marginTop: 4,
        marginLeft: 12,
        fontSize: 12,
        color: '#F04438',
        fontFamily: 'Avenir-Medium',
    },
});
export default TextField;
